import { jsx as _jsx } from "react/jsx-runtime";
import { HStack } from "@chakra-ui/layout";
import React from "react";
const PageHeaderButtonsWrapper = ({ children }) => (_jsx(HStack, Object.assign({ spacing: { base: "2", md: "4" } }, { children: children })));
export default PageHeaderButtonsWrapper;
